import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { ScrollToTop } from './components/ScrollToTop';
import { Home } from './pages/Home';
import { Menu } from './pages/Menu';
import { Reservas } from './pages/Reservas';
import { Sobre } from './pages/Sobre';
import { Donaciones } from './pages/Donaciones';
import { Contacto } from './pages/Contacto';
export function App() {
  return <Router data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <div className="flex flex-col min-h-screen bg-cafe-bg font-sans" data-id="element-2">
        <Navbar data-id="element-3" />
        <main className="flex-grow pt-20" data-id="element-4">
          <Routes data-id="element-5">
            <Route path="/" element={<Home data-id="element-7" />} data-id="element-6" />
            <Route path="/menu" element={<Menu data-id="element-9" />} data-id="element-8" />
            <Route path="/reservas" element={<Reservas data-id="element-11" />} data-id="element-10" />
            <Route path="/sobre" element={<Sobre data-id="element-13" />} data-id="element-12" />
            <Route path="/donaciones" element={<Donaciones data-id="element-15" />} data-id="element-14" />
            <Route path="/contacto" element={<Contacto data-id="element-17" />} data-id="element-16" />
          </Routes>
        </main>
        <Footer data-id="element-18" />
        <Toaster position="bottom-right" toastOptions={{
        style: {
          background: '#F2E8DC',
          color: '#2B1810',
          border: '1px solid #E5D5C5'
        }
      }} data-id="element-19" />
      </div>
    </Router>;
}